import React from 'react';

import { Dropdown } from '@cuemath/web-comps';

import { VALIDITY_MODE, VALIDITY_MODE_OPTIONS, CHANNEL_OPTIONS } from '../constants';
import { Controls, Field, FieldLabel, DateInput } from '../styled-comps';

// The filter/parameter row above the grid. View mode: channel, ratio, validity window
// (+ as-of date). Bulk mode: channel, ratio, and the common valid-from / valid-until
// applied to every created window. All change handlers receive the raw value.
const PayoutControls = ({
  isBulk,
  channel,
  onChannel,
  classRatio,
  onClassRatio,
  ratioOptions,
  validityMode,
  onValidityMode,
  asOfDate,
  onAsOfDate,
  bulkStart,
  onBulkStart,
  bulkEnd,
  onBulkEnd,
  bulkSubmitting,
}) => (
  <Controls>
    <Field>
      <FieldLabel>Mode</FieldLabel>
      <Dropdown
        options={CHANNEL_OPTIONS}
        width="160px"
        height="max-content"
        type="primary"
        value={channel}
        onChange={onChannel}
      />
    </Field>

    <Field>
      <FieldLabel>Class ratio</FieldLabel>
      <Dropdown
        options={ratioOptions}
        width="120px"
        height="max-content"
        type="primary"
        value={classRatio}
        onChange={onClassRatio}
      />
    </Field>

    {!isBulk && (
      <Field>
        <FieldLabel>Show</FieldLabel>
        <Dropdown
          options={VALIDITY_MODE_OPTIONS}
          width="160px"
          height="max-content"
          type="primary"
          value={validityMode}
          onChange={onValidityMode}
        />
      </Field>
    )}

    {!isBulk && validityMode === VALIDITY_MODE.AS_OF && (
      <Field>
        <FieldLabel>Date</FieldLabel>
        <DateInput
          type="date"
          value={asOfDate}
          onChange={e => onAsOfDate(e.target.value)}
        />
      </Field>
    )}

    {isBulk && (
      <>
        <Field>
          <FieldLabel>Valid from (all)</FieldLabel>
          <DateInput
            type="date"
            value={bulkStart}
            disabled={bulkSubmitting}
            onChange={e => onBulkStart(e.target.value)}
          />
        </Field>
        <Field>
          <FieldLabel>Valid until (all, optional)</FieldLabel>
          <DateInput
            type="date"
            value={bulkEnd}
            disabled={bulkSubmitting}
            onChange={e => onBulkEnd(e.target.value)}
          />
        </Field>
      </>
    )}
  </Controls>
);

export default PayoutControls;
